<div class="claim_body">
  <div class="top_panel">
    <h3>Charge Manually</h3>
    <span (click)="close()" class="close">
        <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  </div>
  <div class="formarea">
    <form [formGroup]="pastDueForm" *ngIf="pastDues.length> 0">
      <h3>Select Past Due</h3>
      <div class="table-wrapper">
        <table>
          <tr>
            <th>Select</th>
            <th>Agreement Number</th>
            <th>Due Amount</th>
          </tr>
            <tr *ngFor="let item of pastDues">
              <td><input type="radio" formControlName="agreementNumber" [value]="item?.agreementNumber" (change)="checkPastDueAndProceed($event)"></td>
              <td>{{item?.agreementNumber}}</td>
              <td>{{item?.amountPaid | currency}}</td>
            </tr>
        </table>
      </div>
     
    </form>
    <form [formGroup]="chargemanuallyForm" *ngIf="pastDues.length > 0 && pastDueForm.get('agreementNumber').value || !pastDues?.length">
      <div class="inputprt">
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Category</mat-label>
          <mat-select formControlName="category" (selectionChange)="handleChangeCategory($event)">
            <mat-option value="Premium">Premium</mat-option>
            <mat-option value="Copayment">Copayment</mat-option>
            <mat-option value="Additional Fees">Additional Fees</mat-option>
          </mat-select>
          <mat-error *ngIf="chargemanuallyForm.controls['category'].touched && chargemanuallyForm.controls['category'].hasError('required')">
            This is required field.
          </mat-error>
        </mat-form-field>
        
        <mat-form-field fxFlex="auto" appearance="outline" *ngIf="chargemanuallyForm.get('category').value && chargemanuallyForm.get('category').value === 'Premium' && agreements.length">
          <mat-label>Agreement</mat-label>
          <mat-select formControlName="orderId">
            <mat-option *ngFor="let agreement of agreements" [value]="agreement?.orderId">{{agreement?.agreementNumber}}</mat-option>
          </mat-select>
          <mat-error *ngIf="chargemanuallyForm.controls['orderId'].touched && chargemanuallyForm.controls['orderId'].hasError('required')">
            This is required field.
          </mat-error>
        </mat-form-field>

        <p *ngIf="!agreements?.length && chargemanuallyForm.get('category').value && chargemanuallyForm.get('category').value === 'Premium'">No agreements found</p>

        <mat-form-field fxFlex="auto" appearance="outline" *ngIf="chargemanuallyForm.get('category').value && chargemanuallyForm.get('category').value !== 'Premium' && claims.length">
          <mat-label>Claims</mat-label>
          <mat-select formControlName="claimId">
            <mat-option *ngFor="let claim of claims" [value]="claim?.fileClaimId">{{claim?.fileClaimNumber}}</mat-option>
          </mat-select>
          <mat-error *ngIf="chargemanuallyForm.controls['claimId'].touched && chargemanuallyForm.controls['claimId'].hasError('required')">
            This is required field.
          </mat-error>
        </mat-form-field>

        <p *ngIf="!claims?.length && chargemanuallyForm.get('category').value && chargemanuallyForm.get('category').value !== 'Premium'">No claims found</p>
        
        <mat-form-field fxFlex="auto" appearance="outline" *ngIf="showPaymentField">
          <mat-label>Payments</mat-label>
          <input matInput placeholder="Payments" formControlName="amount"  mask="separator.2" prefix="$" thousandSeparator="," />
          <mat-error *ngIf="chargemanuallyForm.controls['amount'].touched && chargemanuallyForm.controls['amount'].hasError('required')">
            This is required field.
          </mat-error>
        </mat-form-field>
      </div>
      </form>
      <div class="refund_process" *ngIf="chargemanuallyForm.get('category').value">
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
          <mat-tab label="Default Card">
            <form [formGroup]="defaultCardForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Card Holder Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Card Holder Name"
                      formControlName="cardHoldarName"
                      readonly
                    />
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['cardHoldarName'].touched &&
                        defaultCardForm.controls['cardHoldarName'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Card Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      formControlName="cardNumber"
                      [hiddenInput]="true"
                      [mask]="
                        cardType == 'American Express'
                          ? 'XXXX XXXXXX X0000'
                          : 'XXXX XXXX XXXX 0000'
                      "
                      readonly
                    />
                    <span
                      *ngIf="this.defaultCard?.cardType == 'Visa'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/visa-card-logo.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="this.defaultCard?.cardType == 'Mastercard'"
                      class="cardlogo mastercard"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/master-card.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="this.defaultCard?.cardType == 'American Express'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/American-Express.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="this.defaultCard?.cardType == 'Discover'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/discover.png"
                        alt=""
                      />
                    </span>
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['cardNumber'].touched &&
                        defaultCardForm.controls['cardNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['cardNumber'].touched &&
                        defaultCardForm.controls['cardNumber'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter Valid Card Number
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Expiary Date </label>
                  <span>
                    <input
                      type="text"
                      placeholder="00/00"
                      formControlName="monthYear"
                      mask="00/00"
                     readonly
                    />
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      Enter valid Expiry month and year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        defaultCardForm.controls['expiryYear'].valid
                      "
                    >
                      Enter Valid Expire Month.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['expiryMonth'].hasError(
                          'min'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Expiry Month value should be greater then 1.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        defaultCardForm.controls['expiryMonth'].valid
                      "
                    >
                      Enter Valid Expire Year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        defaultCardForm.controls['monthYear'].touched &&
                        defaultCardForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !defaultCardForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter valid expire month and year.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> CVV </label>
                  <span>
                    <input
                      type="password"
                      placeholder="CVV"
                      formControlName="cvv"
                      [mask]="cardType == 'American Express' ? '0000' : '000'"
                     readonly
                    />
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['cvv'].touched &&
                        defaultCardForm.controls['cvv'].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        defaultCardForm.controls['cvv'].touched &&
                        defaultCardForm.controls['cvv'].hasError('mask')
                      "
                    >
                      Enter valid cvv code.
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Credit card">
            <form [formGroup]="cardDetailsForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Card Holder Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Card Holder Name"
                      formControlName="cardHoldarName"
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardHoldarName'].touched &&
                        cardDetailsForm.controls['cardHoldarName'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Card Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      formControlName="cardNumber"
                      [hiddenInput]="true"
                      [mask]="
                        cardType == 'American Express'
                          ? 'XXXX XXXXXX X0000'
                          : 'XXXX XXXX XXXX 0000'
                      "
                      (ngModelChange)="detectCardType($event)"
                      
                    />
                    <span
                      *ngIf="cardType && cardType == 'Visa'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/visa-card-logo.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'Mastercard'"
                      class="cardlogo mastercard"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/master-card.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'American Express'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/American-Express.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'Discover'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/discover.png"
                        alt=""
                      />
                    </span>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardNumber'].touched &&
                        cardDetailsForm.controls['cardNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardNumber'].touched &&
                        cardDetailsForm.controls['cardNumber'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter Valid Card Number
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Expiration Date </label>
                  <span>
                    <input
                      type="text"
                      placeholder="00/00"
                      formControlName="monthYear"
                      mask="00/00"
                     
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      Enter valid Expiry month and year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        cardDetailsForm.controls['expiryYear'].valid
                      "
                    >
                      Enter Valid Expire Month.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Expiry Month value should be greater then 1.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        cardDetailsForm.controls['expiryMonth'].valid
                      "
                    >
                      Enter Valid Expire Year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter valid expire month and year.
                    </mat-error>
                    <mat-error *ngIf="
                      !cardDetailsForm.controls['monthYear'].hasError('required') && 
                      cardDetailsForm.controls['expiryMonth'].hasError('notValid') && 
                      !cardDetailsForm.controls['monthYear'].hasError('mask') &&
                      cardDetailsForm.controls['monthYear'].touched &&
                      !cardDetailsForm.controls['expiryYear'].hasError('min')">
                          Enter Valid Expire Month.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> CVV </label>
                  <span>
                    <input
                      type="password"
                      placeholder="CVV"
                      formControlName="cvv"
                      [mask]="cardType == 'American Express' ? '0000' : '000'"
                     
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cvv'].touched &&
                        cardDetailsForm.controls['cvv'].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cvv'].touched &&
                        cardDetailsForm.controls['cvv'].hasError('mask')
                      "
                    >
                      Enter valid cvv code.
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Bank">
            <form [formGroup]="bankDetailsForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Account Holder Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Account Holder Name"
                      formControlName="nameOnAccount"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['nameOnAccount'].touched &&
                        bankDetailsForm.controls['nameOnAccount'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['nameOnAccount'].touched &&
                        bankDetailsForm.controls['nameOnAccount'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Name must be minimum 2 digits
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Account Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      mask="0000*"
                      minlength="4"
                      formControlName="accountNumber"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['accountNumber'].touched &&
                        bankDetailsForm.controls['accountNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['accountNumber'].touched &&
                        bankDetailsForm.controls['accountNumber'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Account Number must be minimum 4 digits.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Routing No </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Routing No"
                      formControlName="routingNumber"
                      mask="000000000"
                      (ngModelChange)="getBankDetail()"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['routingNumber'].touched &&
                        bankDetailsForm.controls['routingNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['routingNumber'].touched &&
                        (bankDetailsForm.controls['routingNumber'].hasError(
                          'minlength'
                        ) ||
                          bankDetailsForm.controls['routingNumber'].hasError(
                            'maxlength'
                          ))
                      "
                    >
                      Routing Number must be 9 digits.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Bank Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Bank Name"
                      formControlName="bankName"
                      disabled
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['bankName'].touched &&
                        bankDetailsForm.controls['bankName'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Transaction Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Transaction Number"
                      formControlName="transactionNumber"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['transactionNumber']
                          .touched &&
                        bankDetailsForm.controls[
                          'transactionNumber'
                        ].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Check">
            <form [formGroup]="chequeDetailForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label>Check Number</label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      formControlName="checkNumber"
                      mask="0000*"
                    />
                    <mat-error
                      *ngIf="
                        chequeDetailForm.controls['checkNumber'].touched &&
                        chequeDetailForm.controls['checkNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        chequeDetailForm.controls['checkNumber'].touched &&
                        chequeDetailForm.controls['checkNumber'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Check Number must be minimum 4 digits.
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button type="button" class="sub-button" (click)="checkPaymentAndSubmit()"><span>Charge</span></button>
        <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
      </div>
  </div>
</div>
